import { HttpClient } from '@angular/common/http';
import { DataUtils } from 'app/core/util/data-util.service';
import { Injectable } from '@angular/core';
import { FileUtilsService, IMediaOptions } from 'app/core/util/file-utils.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MediaComponent } from 'app/layouts/media/media.component';

@Injectable({
  providedIn: 'root', 
})
export class UtilsService {
  constructor(private http: HttpClient,
    private fileExtensionConfig: FileUtilsService,
    private modalService: NgbModal,
    private dataUtils: DataUtils) { }
  getDocumentIcon(docType: string | null | undefined): string {
    if (docType === 'link') {
      return "external-link dark";
    }
    return this.fileExtensionConfig.getFileTypeIcon(docType);
  }

  viewOpenning(path: string): void {
    if (path) {
      const path_comp = path.split(".");
      const mediaOptions: IMediaOptions|undefined = this.fileExtensionConfig.getFileOptions(path_comp[path_comp.length-1]);
       console.log(path_comp[path_comp.length-1], mediaOptions);
      if(!mediaOptions){
        window.open(path);
      }else if(mediaOptions.openPopUp){
        console.log(path);
        const modelRef = this.modalService.open(MediaComponent,
          { modalDialogClass: 'custom-dialog modal-dialog-centered modal-lg', size: 'lg' });
          modelRef.componentInstance.path = mediaOptions.fileUrlPrefix+path;
          modelRef.componentInstance.type = mediaOptions.category
          modelRef.componentInstance.modelRef = modelRef;
      }else{
        this.http
          .get(`${mediaOptions?.fileUrlPrefix}${path}`, { responseType: 'text' })
          .subscribe((res: any) => {
            if (res) {
              const json = JSON.parse(res);
              this.dataUtils.openFile(String(json.data), mediaOptions?.mediaType);
            }
            else {
              alert("No data found");
            }
          });
      }
    }
  }
}


